import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import AddQuestionEditing from './addquestionediting';
import AddQuestionUI from './addquestionui';

export default class AddQuestion extends Plugin {
  static get requires() {
    return [AddQuestionEditing, AddQuestionUI];
  }

  init() {
    console.log('AddQuestion was initialized', this.editor);
  }
}
